import { DiModuleBuilder } from "@iot-platform/core";
import { NotebookMessageDatasource } from "@notebook/data/datasources/notebook-message.datasource";
import { NotebookDatasource } from "@notebook/data/datasources/notebook.datasource";
import { NotebookMessageMapper } from "@notebook/data/mappers/notebook-message.mapper";
import { NotebookMapper } from "@notebook/data/mappers/notebook.mapper";
import { NotebookMessageImplRepository } from "@notebook/data/repositories/notebook-message.impl-repository";
import { NotebookImplRepository } from "@notebook/data/repositories/notebook.impl-repository";
import type { NotebookMessageRepository } from "@notebook/domain/repositories/notebook-message.repository";
import type { NotebookRepository } from "@notebook/domain/repositories/notebook.repository";
import { NotebookGetByIdUseCase } from "@notebook/domain/usecases/notebook-get-by-id.usecase";
import { NotebookMessageCreateUseCase } from "@notebook/domain/usecases/notebook-message-create.usecase";
import { NotebookMessageDeleteUseCase } from "@notebook/domain/usecases/notebook-message-delete.usecase";
import { NotebookMessageFileCreateUseCase } from "@notebook/domain/usecases/notebook-message-file-create.usecase";
import { NotebookMessageFileDeleteUseCase } from "@notebook/domain/usecases/notebook-message-file-delete.usecase";
import { NotebookMessageGetAllUseCase } from "@notebook/domain/usecases/notebook-message-get-all.usecase";
import { NotebookMessageGetByIdUseCase } from "@notebook/domain/usecases/notebook-message-get-by-id.usecase";
import { NotebookMessageUpdateUseCase } from "@notebook/domain/usecases/notebook-message-update.usecase";
import { notebookTypes } from "@notebook/notebook-types.di";
import { AddMessageModalViewModel } from "@notebook/presentation/components/diary/add-message/add-message-modal.viewmodel";
import { DetailMessageModalViewModel } from "@notebook/presentation/components/diary/detail-message/detail-message-modal.viewmodel";
import { DiaryComponentViewmodel } from "@notebook/presentation/components/diary/diary.viewmodel";
import { EditMessageModalViewModel } from "@notebook/presentation/components/diary/edit-message/edit-message-modal.viewmodel";
import { MessageModalFormViewmodel } from "@notebook/presentation/components/diary/message-modal-form.viewmodel";
import { NotebookPageViewmodel } from "@notebook/presentation/pages/notebook/notebook-page.viewmodel";
import { ContainerModule } from "inversify";

const webNotebookModule = new DiModuleBuilder();

webNotebookModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(NotebookDatasource).toSelf();
        bind(NotebookMessageDatasource).toSelf();
    }),
    mappers: new ContainerModule(({ bind }) => {
        bind(NotebookMapper).toSelf();
        bind(NotebookMessageMapper).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<NotebookRepository>(
            notebookTypes.repositories.NotebookRepository,
        ).to(NotebookImplRepository);
        bind<NotebookMessageRepository>(
            notebookTypes.repositories.NotebookMessageRepository,
        ).to(NotebookMessageImplRepository);
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(NotebookGetByIdUseCase).toSelf();
        bind(NotebookMessageCreateUseCase).toSelf();
        bind(NotebookMessageDeleteUseCase).toSelf();
        bind(NotebookMessageFileDeleteUseCase).toSelf();
        bind(NotebookMessageFileCreateUseCase).toSelf();
        bind(NotebookMessageGetAllUseCase).toSelf();
        bind(NotebookMessageGetByIdUseCase).toSelf();
        bind(NotebookMessageUpdateUseCase).toSelf();
    }),
    viewModels: new ContainerModule(({ bind }) => {
        bind(AddMessageModalViewModel).toSelf();
        bind(DetailMessageModalViewModel).toSelf();
        bind(DiaryComponentViewmodel).toSelf();
        bind(EditMessageModalViewModel).toSelf();
        bind(NotebookPageViewmodel).toSelf();
        bind(MessageModalFormViewmodel).toSelf();
    }),
}));

webNotebookModule.registerModule();

export { webNotebookModule };
